(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kmc-bundle-landing"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kmc-bundle-landing')) {
  customElements.define('kmc-bundle-landing', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      const selector = this.querySelector('[data-variant]');
      if (!selector) return;
      const update = () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        this.querySelector('[data-price]').textContent = option.dataset.price;
        this.querySelector('[data-savings]').textContent = option.dataset.saving;
        this.querySelector('[data-sticky-price]').textContent = option.dataset.price;
        this.querySelector('[data-sticky-caption]').textContent = option.dataset.title + ' · ' + option.dataset.price;
        const button = this.querySelector('[data-buy]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? this.dataset.unavailableLabel : this.dataset.addLabel;
      };
      selector.addEventListener('change', update);
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kmc-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('kmc-product-page')) {
  customElements.define('kmc-product-page', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.syncGallery = () => {
        const layout = this.mobileQuery.matches ? this.dataset.mobileLayout : this.dataset.galleryLayout;
        const showAll = layout !== 'thumbnails';
        this.querySelectorAll('[data-media-id]').forEach(panel => {
          const shouldHide = !showAll && panel.dataset.mediaId !== this.dataset.activeMedia;
          if (shouldHide && !panel.hidden) this.pauseMedia(panel);
          panel.hidden = shouldHide;
        });
      };
      this.mobileQuery.addEventListener('change', this.syncGallery);
      this.syncGallery();
      this.buy = this.querySelector('[name="add"]');
      if (this.buy) this.buy.disabled = this.buy.dataset.canBuy !== 'true';
      this.addEventListener('change', event => {
        if (event.target.matches('[data-option-value-id]')) this.selectOption(event.target);
      }, {signal: this.abort.signal});
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-show-media]');
        if (!thumb) return;
        this.dataset.activeMedia = thumb.dataset.showMedia;
        this.syncGallery();
        this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
      }, {signal: this.abort.signal});
    }
    pauseMedia(panel) {
      panel.querySelectorAll('video').forEach(video => video.pause());
      panel.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.request?.abort();
      this.mobileQuery?.removeEventListener('change', this.syncGallery);
    }
    async selectOption(input) {
      this.request?.abort();
      const controller = new AbortController();
      this.request = controller;
      this.buy.disabled = true;
      this.setAttribute('aria-busy','true');
      this.querySelector('.kmcp-status').textContent = '';
      const selected = [...this.querySelectorAll('[data-option-value-id]:checked')].map(node => node.dataset.optionValueId);
      const url = new URL(input.dataset.productUrl || this.dataset.productUrl, location.origin);
      url.searchParams.set('option_values', selected.join(','));
      url.searchParams.set('section_id', this.dataset.sectionId);
      const focusedId = input.id;
      try {
        const response = await fetch(url, {signal:controller.signal});
        if (!response.ok) throw new Error('Section unavailable');
        const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
        const replacement = documentFragment.querySelector('kmc-product-page');
        if (!replacement || !replacement.querySelector('[name="id"]')) throw new Error('Missing section');
        if (controller.signal.aborted) return;
        const quantity = this.querySelector('[name="quantity"]');
        const nextQuantity = replacement.querySelector('[name="quantity"]');
        nextQuantity.value = quantity.value;
        if (!nextQuantity.checkValidity()) nextQuantity.value = nextQuantity.min || '1';
        this.querySelectorAll('.kmcp-details details').forEach((detail, index) => {
          const nextDetail = replacement.querySelectorAll('.kmcp-details details')[index];
          if (nextDetail) nextDetail.open = detail.open;
        });
        const nextUrl = new URL(location.href);
        nextUrl.pathname = url.pathname;
        if (replacement.dataset.variant) {
          nextUrl.searchParams.set('variant',replacement.dataset.variant);
          nextUrl.searchParams.delete('option_values');
        } else {
          nextUrl.searchParams.delete('variant');
          nextUrl.searchParams.set('option_values',selected.join(','));
        }
        history.replaceState({},'',nextUrl);
        this.replaceWith(replacement);
        replacement.querySelectorAll('[data-option-value-id]').forEach(node => {
          if (node.id === focusedId) node.focus({preventScroll:true});
        });
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.removeAttribute('aria-busy');
        this.querySelector('.kmcp-status').textContent = this.dataset.error;
        this.querySelectorAll('[data-option-value-id]').forEach(node => { node.checked = node.defaultChecked; });
        this.buy.disabled = this.buy.dataset.canBuy !== 'true';
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
